export default "__VITE_ASSET__DkwoGvx8__"